import { render, staticRenderFns } from "./VrEmergencyBulletinBoard.vue?vue&type=template&id=0aac729e&scoped=true&"
import script from "./VrEmergencyBulletinBoard.vue?vue&type=script&lang=js&"
export * from "./VrEmergencyBulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./VrEmergencyBulletinBoard.vue?vue&type=style&index=0&id=0aac729e&scoped=true&lang=css&"
import style1 from "./VrEmergencyBulletinBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac729e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
